import api from "@/api.js";
import apiV2 from "@/apiV2";
import outcomePlanQuestionnaireOptions from "./outcomePlanQuestionnaireOptions/";

export default {
  namespaced: true,
  modules: {
    outcomePlanQuestionnaireOptions
  },
  state: {
    list: [],
    listLoading: false,
    selectedOutcomePlanQuestion: null
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
    setSelectedOutcomePlanQuestion(state, payload) {
      state.selectedOutcomePlanQuestion = payload;
    }
  },
  actions: {
    async loadAllByOutcomesID({ commit }, id) {
      commit("setListLoading", true);
      let list = await api.get("outcomePlanQuestionnaire/byOutcomesID", {
        params: { id: id }
      });
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadAllByOutcomesIDWithOptions({ commit }, id) {
      commit("setListLoading", true);
      let list = await apiV2.get(
        "OutcomeQuestionnaire/ForOutcome",
        { params: { id: id } }
      );
      console.log(list);
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadByID({ commit }, id) {
      commit("setListLoading", true);
      let list = await api.get("outcomePlanQuestionnaire/byID", {
        params: { id: id }
      });
      commit("setSelectedOutcomePlanQuestion", list.data[0]);
      commit("setListLoading", false);
    },
    async new({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("outcomePlanQuestionnaire", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });

      dispatch("loadAllByOutcomesID", payload.outcomes_id);
      return returnData;
    },
    async save({ dispatch }, payload) {
      let returnData = {};
      await api
        .put("outcomePlanQuestionnaire", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });

      dispatch("loadAllByOutcomesID", payload.outcomes_id);
      return returnData;
    }
  },
  getters: {
    list(state) {
      return state.list;
    },
    listLoading(state) {
      return state.listLoading;
    },
    selectedOutcomePlanQuestion(state) {
      return state.selectedOutcomePlanQuestion;
    }
  }
};
